export function getReducerState (state, reducerKey) {
  return state[reducerKey]
}



// WEBPACK FOOTER //
// ./src/utils/redux/getReducerState.js